import api from './api'

export default {
  async getByUserId(userId) {
    const { data } = await api.get(`/admin/user-documents?_filters_[]=user_id&user_id=${userId}`)
    return data
  },

  async create(documentData) {
    const formData = new FormData()
    
    // Append all fields to FormData
    if (documentData.title) formData.append('title', documentData.title)
    if (documentData.user_id) formData.append('user_id', documentData.user_id)
    if (documentData.document_type_id) formData.append('document_type_id', documentData.document_type_id)
    if (documentData.file) formData.append('file', documentData.file)

    const { data } = await api.post('/admin/user-documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data
  },

  async update(id, documentData) {
    const formData = new FormData()
    
    // Add _method for Laravel to recognize PUT request
    formData.append('_method', 'PUT')
    
    // Append all fields to FormData
    if (documentData.title) formData.append('title', documentData.title)
    if (documentData.user_id) formData.append('user_id', documentData.user_id)
    if (documentData.document_type_id) formData.append('document_type_id', documentData.document_type_id)
    if (documentData.file) formData.append('file', documentData.file)

    const { data } = await api.post(`/admin/user-documents/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/user-documents/${id}`)
    return data
  },

  async download(id) {
    const response = await api.get(`/admin/user-documents/${id}/download`, {
      responseType: 'blob'
    })
    return response
  }
}

